// src/context/FormContext.js
import { createContext, useContext, useState } from "react";

const FormContext = createContext();

// export const FormProvider = ({ children }) => {
//   // Try to load from localStorage (so refresh doesn’t clear it)
//   const [formData, setFormData] = useState(() => {
//     const saved = sessionStorage.getItem("formData");
//     return saved ? JSON.parse(saved) : {};
//   });

//   // Persist whenever formData changes
//   useEffect(() => {
//     sessionStorage.setItem("formData", JSON.stringify(formData));
//   }, [formData]);

//   return (
//     <FormContext.Provider value={{ formData, setFormData }}>
//       {children}
//     </FormContext.Provider>
//   );
// };

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({});

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};

// custom hook for easier usage
export const useFormData = () => useContext(FormContext);
